import { defineStore } from 'pinia'
import { store } from '../index'
import storage from '@/libs/storage'
import * as http from '@/libs/http';
import { isEmpty } from '@/libs/utils';

export const useAppStore = defineStore('app',{
    state:()=>({
        site: storage.getJson("site",{
            title: "",
            ctitle: "",
            keywords: "",
            description: "",
            is_wechat: 0
        })
    }),
    actions: {
        async getData(){
            if(!isEmpty(this.site.title)){
                return this.site;
            }
            
            let { code,data } = await http.get("common/init");
            if(code){
                this.site = data;
                storage.setJson("site",data);
                document.querySelector('meta[name="keywords"]').setAttribute('content', data.keywords);
                document.querySelector('meta[name="description"]').setAttribute('content', data.description);
            }

            return data;
        }
    }
});

export const useAppStoreWithOut = () => {
  return useAppStore(store)
}